exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cof-field[data-v-bab42b42] {\n  margin-right: 5px;\n}\n.errors[data-v-bab42b42] {\n  color: #ff0000 !important;\n}\n.key-wrap[data-v-bab42b42] {\n  max-width: 100px;\n  word-wrap: break-word;\n}\n.fee-checkbox[data-v-bab42b42] {\n  -webkit-appearance: checkbox;\n}\n.updateAt[data-v-bab42b42] {\n  font-size: 10px;\n  width: 155px;\n}\n.form-max div[data-v-bab42b42] {\n  width: 100%;\n}\np.c1[data-v-bab42b42] {\n  color: #13ce67;\n}\np.c3[data-v-bab42b42] {\n  color: #616f7b;\n}\n.services-split[data-v-bab42b42] {\n  display: flex;\n  justify-content: space-between;\n}", ""]);

// exports
